/* eslint-disable @typescript-eslint/no-explicit-any */
export const shuffle = (array: any[]) => {
  return array.sort(() => Math.random() - 0.5)
}

const createSeededRandom = (seed: number) => {
  let value = seed

  return () => {
    value = (value * 1664525 + 1013904223) % 4294967296
    return value / 4294967296
  }
}

export const shuffleWithSeed = <T>(array: T[], seed: number): T[] => {
  const result = [...array]
  const random = createSeededRandom(seed)

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }

  return result
}
